import { Injectable, NgModule } from '@angular/core';
import { CustomCurrencyPipe } from './custom-currency.pipe';
import { Day_diffPipe } from './day_diff.pipe';
import { CommonModule } from '@angular/common';
import { LanguagePipe } from './language.pipe';

@Injectable({
  providedIn: 'root'
})
@NgModule({
  imports: [CommonModule],
  declarations: [CustomCurrencyPipe, Day_diffPipe, LanguagePipe],
  exports: [CustomCurrencyPipe, Day_diffPipe, LanguagePipe]
})
export class PipesModule {}
